// extracted by mini-css-extract-plugin
export default {"navIcon1":"MenuButton_navIcon1__E5JBJ","open":"MenuButton_open__k3h1G"};